import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const avatarPlaceholderFn = /* @__PURE__ */ createRecipe('avatar-placeholder', {
  "size": "m"
}, [])

const avatarPlaceholderVariantMap = {
  "size": [
    "s",
    "m",
    "l"
  ]
}

const avatarPlaceholderVariantKeys = Object.keys(avatarPlaceholderVariantMap)

export const avatarPlaceholder = /* @__PURE__ */ Object.assign(memo(avatarPlaceholderFn.recipeFn), {
  __recipe__: true,
  __name__: 'avatarPlaceholder',
  __getCompoundVariantCss__: avatarPlaceholderFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: avatarPlaceholderVariantKeys,
  variantMap: avatarPlaceholderVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, avatarPlaceholderVariantKeys)
  },
  getVariantProps: avatarPlaceholderFn.getVariantProps,
})